import { render, staticRenderFns } from "./inStockOrder.vue?vue&type=template&id=58dc9b98&"
import script from "./inStockOrder.vue?vue&type=script&lang=js&"
export * from "./inStockOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports